// utils/encryption.js
export const encryptData = (data) => {
  return btoa(encodeURIComponent(data));
};

export const decryptData = (encryptedData) => {
  return decodeURIComponent(atob(encryptedData));
};
